// SparesHub shared config / taxonomy
export const SUPPORT_PHONE = "+91-94227-99760";
export const SUPPORT_PHONE_TEL = "+919422799760";
export const SUPPORT_WHATSAPP = "919422799760";
export const SUPPORT_EMAIL = "contact@spareshub.com";

// Structured lot classification (used consistently across the app + admin)
export const VEHICLE_TYPES = ["Car", "2-Wheeler", "3-Wheeler", "Commercial Vehicle", "Off-Road Vehicle"];
export const BRAND_TYPES = ["OEM Genuine", "Aftermarket Brand", "Unbranded"];
export const PARTS_CONDITIONS = ["Brand New", "Used", "Brand New (slight wear & tear)", "Refurbished", "Damaged"];
export const PACKAGING_CONDITIONS = ["Perfect as New", "Slight wear & tear", "Packaging Damaged", "Packaging Not Available"];

export function lotCode(lot) {
  if (lot?.lot_code) return lot.lot_code;
  const id = String(lot?.id || "");
  return "SH-" + id.replace(/-/g, "").slice(0, 7).toUpperCase();
}

export function brandTypeClass(bt) {
  if (bt === "OEM Genuine") return "bg-darkteal/10 text-darkteal";
  if (bt === "Aftermarket Brand") return "bg-brand/10 text-brand";
  return "bg-navy/10 text-subtext";
}
